const OKBarChart = require('okCharts/OKBarChart/OKBarChart');

export default OKBarChart;